import { render } from "./RDataList.vue?vue&type=template&id=25840df2"
import script from "./RDataList.vue?vue&type=script&lang=js"
export * from "./RDataList.vue?vue&type=script&lang=js"

import "./RDataList.vue?vue&type=style&index=0&id=25840df2&lang=css"
script.render = render

export default script